module.exports = __webpack_public_path__ + "img/Stonewall.80fd66ff.png";